import { useCallback } from 'react';
import { getFocusedNodeIds } from '@components/MainStage/focusOn.helpers';
import { getFocusOnState } from '@components/MainStage/focusOn.store';
import { canvasState } from '@components/MainStage/store';
import { useProjectFilters } from '@context/ProjectFilters/ProjectFiltersProvider';
import { useProjectDashboardActions } from '@store/zustand/project-dashboard-filters/project-dashboard-filters.store';

const useFocusOn = () => {
  const { handleClearAllFilters } = useProjectFilters();
  const { clearDashboardFilters } = useProjectDashboardActions();

  const enterFocus = useCallback(
    (sourceId: string, sourceName: string) => {
      const focusedIds = getFocusedNodeIds(canvasState().nodes, sourceId);

      handleClearAllFilters();
      clearDashboardFilters();

      getFocusOnState().setFocus({ sourceId, sourceName, focusedIds });
    },
    [handleClearAllFilters, clearDashboardFilters],
  );

  const exitFocus = useCallback(() => {
    getFocusOnState().clear();
  }, []);

  return { enterFocus, exitFocus };
};

export default useFocusOn;
